









































































































import { Component, Vue, Prop } from "vue-property-decorator";
import VToolbar from "../../common/components/VToolbar.vue";
import InvoiceService from "@/usecases/accounting/invoice-service";
import EstimateService from "../../../usecases/accounting/estimate-service";
// import ExpensesService from "@/usecases/accounting/expenses-service";
import Estimate from "../../../usecases/accounting/estimate";
import VIconEdit from "../../../components/icons/VIconEdit.vue";
import VIconPrint from "../../../components/icons/VIconPrint.vue";
import VIconEstimate from "../../../components/icons/VIconEstimate.vue";
import EstimateApi from "../../../api/accounting/estimate-api";
import PrintApi from "../../../api/accounting/print-api";
import { client } from "../../../api/request";
import InvoiceApi from "../../../api/accounting/invoice-api";
// import ExpensesApi from "../../../api/accounting/expenses-api";
import VSearchBar from "../../../components/VSearchBar.vue";
import BillingRuleApi from "@/accounting/api/billing-rule-api";
import EstimateStatus from "../components/EstimateStatus.vue";
import { ServiceArise, getUserAriseServices } from "../../../api/service-api";
import ProjectAccountingTabs from "@/components/ProjectAccountingTabs.vue";
import { newExpense, getExpenses } from "@/api/cost/expenses-api";
// import { isThisHour } from "date-fns";

const billingRuleApi = new BillingRuleApi(client);
const estimateApi = new EstimateApi(client);
const printApi = new PrintApi(client);
const service = new EstimateService(estimateApi);
const invoiceApi = new InvoiceApi(client);
// const expensesApi = new ExpensesApi(client);
const estimateService = new EstimateService(estimateApi);
const invoiceService = new InvoiceService(invoiceApi, billingRuleApi);
// const expensesService = new ExpensesService(expensesApi);

@Component({
  components: {
    ProjectAccountingTabs,
    EstimateStatus,
    VToolbar,
    VSearchBar,
    VIconEdit,
    VIconPrint,
    VIconEstimate
  }
})
export default class EstimateListPage extends Vue {
  @Prop() projectId?: string;
  @Prop({ type: Boolean }) editon!: boolean;
  estimateItems: Estimate[] = [];
  printStatus: boolean[] = [];
  resetLoadInfinite = 0;

  roles: ServiceArise[] = [];

  searchOptions = {
    projectName: ""
  };

  async create() {
    const id = await estimateApi.create(this.projectId);
    this.edit(id);
  }

  edit(id: number) {
    this.$router.push({
      name: "estimate-edit",
      params: {
        id: String(id)
      }
    });
  }

  search(projectName: string) {
    this.searchOptions = { projectName };
    this.initServiceRoles();
    this.initEstimateList(this.searchOptions);
  }

  async duplicate(id: number) {
    const newEstimateId = await service.duplicate(id);
    this.edit(newEstimateId);
  }

  async createPdf(id: number, index: number, printsExcludeTax: boolean) {
    if (this.printStatus.includes(true)) {
      alert(
        "現在他の見積書で印刷を生成中です。時間をおいてからもう一度試してください。"
      );
    }

    this.$set(this.printStatus, index, true);
    try {
      const url = await printApi.getEstimatePrint(
        id,
        this.$store.state.accessToken,
        printsExcludeTax
      );
      window.open(url, "見積書印刷");
    } finally {
      this.$set(this.printStatus, index, false);
    }
  }

  purchase(id: number) {
    this.$router.push({
      name: "estimate-purchase",
      params: {
        estimateId: String(id)
      }
    });
  }

  // estimateを元にinvoiceを保存して編集ページに移動する
  async invoice(id: number) {
    const estimate = await service.find(id);
    if (!estimate) return;

    const invoiceId = await invoiceService.invoice(estimate);
    this.$router.push({
      name: "invoice-edit",
      params: {
        id: String(invoiceId)
      }
    });
    this.$store.dispatch("getStatusProject");
  }

  async newExpense(id: number) {
    // TODO: 見積書と経費計算書が1:1対応なら挙動を修正
    // const estimate = await service.find(id);
    // if (!estimate) return;
    await newExpense(id.toString());

    const pId = String(this.projectId);
    const expenses = await getExpenses(pId);
    this.$router.push({
      name: "expenses-edit",
      params: {
        expenseId: expenses[0].id
      }
    });
  }

  async changeStatus(id: string, status: string) {
    await estimateService.changeStatus(id, status);
    await this.initServiceRoles();
    await this.initEstimateList(this.searchOptions);
    this.$store.dispatch("getStatusProject");
  }

  get service() {
    return this.$store.state.service;
  }

  protected created() {
    this.initServiceRoles();
    // this.initEstimateList(); // 初回も自動ロードされる
  }

  private async initServiceRoles() {
    this.roles = await getUserAriseServices();
  }

  currentOptions(currentLength: number, options?: { projectName: string }) {
    const new_options = {
      ...options,
      projectId: this.projectId,
      estimateCount: currentLength
    };

    return new_options;
  }

  async getEstimateList30(options?: any) {
    // 現在の件数は、内容を表示している estimateItems から直接取得
    const new_options = this.currentOptions(this.estimateItems.length, options);
    const newEstimateItems: Estimate[] = await estimateApi.findAll(new_options);
    return newEstimateItems;
  }

  // 初期化を区別
  private async initEstimateList(options?: { projectName: string }) {
    this.resetLoadInfinite += 1; // リロードリセット
    const new_options = this.currentOptions(0, options); // 取得開始を0件に

    this.estimateItems = await estimateApi.findAll(new_options);
    for (var i = 0; i < this.estimateItems.length; i++) {
      this.printStatus.push(false);
    }
  }

  /**
   * 最下部 自動リロード
   */
  // TODO: 表示条件変更時に、表示完了の際に 検索結果はありません が出てしまう事がある
  async loadInfinite($state: any) {
    const loadedEstimateItems: Estimate[] = await this.getEstimateList30(
      this.searchOptions
    );

    // 表示するデータがあれば表示、なければ終了
    if (loadedEstimateItems.length) {
      if (this.estimateItems.length == 0) {
        this.estimateItems = loadedEstimateItems;
      } else {
        this.estimateItems = this.estimateItems.concat(loadedEstimateItems);
      }
      for (var i = 0; i < this.estimateItems.length; i++) {
        this.printStatus.push(false);
      }

      $state.loaded();
    } else {
      $state.complete();
    }
  }
}
